import React from 'react';
import PropTypes from 'prop-types';
import { List, ListItem, ListItemText, makeStyles } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { Star } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  roleItem: {
    padding: theme.spacing(0.5, 0)
  },
  starIcon: {
    color: theme.palette.warning.main,
    fontSize: '1.1rem'
  }
}));

const RolesDisplayList = ({ roles, loading }) => {
  const classes = useStyles();

  if (loading) {
    return (
      <>
        <Skeleton height={32} />
        <Skeleton height={32} />
        <Skeleton height={32} />
      </>
    );
  }

  return (
    <List disablePadding>
      {roles.map(entry => (
        <ListItem
          key={entry.projectRole.id}
          disableGutters
          className={classes.roleItem}
        >
          <ListItemText primary={entry.projectRole.displayText} />
          {entry.isDefault && <Star className={classes.starIcon} />}
        </ListItem>
      ))}
    </List>
  );
};

RolesDisplayList.propTypes = {
  roles: PropTypes.arrayOf(
    PropTypes.shape({
      projectRole: PropTypes.shape({
        id: PropTypes.string.isRequired,
        displayText: PropTypes.string.isRequired
      }).isRequired,
      isDefault: PropTypes.bool
    })
  ).isRequired,
  loading: PropTypes.bool
};

export default RolesDisplayList;
